import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'app-forgotten-password',
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './forgotten-password.component.html',
  styleUrl: './forgotten-password.component.scss',
})
export class ForgottenPasswordComponent {
  form!: FormGroup;

  loading: boolean = false;

  error?: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    private destroyRef: DestroyRef
  ) {
    this.form = fb.group({
      email: fb.control('', [Validators.required, Validators.email]),
    });
  }

  forgottenPassword() {
    if (this.form.valid) {
      this.loading = true;

      this.userService
        .forgottenPassword(this.form.controls['email'].value)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            this.router.navigateByUrl('forgotten-password/success');
            this.loading = false;
          },
          error: (err: HttpErrorResponse) => {
            this.error = err.error.message;
            this.loading = false;
          },
        });
    } else {
      this.error = 'Invalid email address';
    }
  }
}
